import { GiroWebappError } from 'model/error';
import {  IncomeStatementYearlyFilter, YearlyIncomeStatement } from 'model/income-statement';
import { action } from 'typesafe-actions';
import { GetYearlyIncomeStatementTypes } from './types';

export const getYearlyIncomeStatementRequest = (request: IncomeStatementYearlyFilter) => action(GetYearlyIncomeStatementTypes.GET_YEARLY_INCOME_STATEMENT_REQUEST, request);
export const getYearlyIncomeStatementSuccess = (response: YearlyIncomeStatement) => action(GetYearlyIncomeStatementTypes.GET_YEARLY_INCOME_STATEMENT_SUCCESS, response);
export const getYearlyIncomeStatementError = (error: GiroWebappError) => action(GetYearlyIncomeStatementTypes.GET_YEARLY_INCOME_STATEMENT_ERROR, error);
export const getYearlyIncomeStatementResetState = () => action(GetYearlyIncomeStatementTypes.GET_YEARLY_INCOME_STATEMENT_RESET_STATE);
